module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-02.31493fb6.jpg";